import React from 'react';
import { Typography, Box } from '@mui/material';

const Dashboard = () => {
  return (
    <Box>
      <Typography variant="h4">Dashboard</Typography>
      <Typography variant="body1" sx={{ mt: 2 }}>
        Welcome to the facial biometric management system.
      </Typography>
    </Box>
  );
};

export default Dashboard; 